module.exports = __webpack_public_path__ + "static/media/brush-script-mt-kursiv.7655d129.ttf";